import { render, staticRenderFns } from "./AlertOccurrences.vue?vue&type=template&id=064cc186&scoped=true"
import script from "./AlertOccurrences.vue?vue&type=script&lang=js"
export * from "./AlertOccurrences.vue?vue&type=script&lang=js"
import style0 from "./AlertOccurrences.vue?vue&type=style&index=0&id=064cc186&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064cc186",
  null
  
)

export default component.exports